// 1	University of Port Harcourt	Port Harcourt
// 2	University of Ibadan	Ibadan
// 3	University of Ilorin	Ilorin
// 4	University of Lagos	Lagos ...
// 5	Obafemi Awolowo University	Ile-Ife
// 7	University of Nigeria	Nsukka ...
// 8	Ahmadu Bello University	Zaria
// 9	Olabisi Onabanjo University	Ago Iwoye ...
// 10	Adekunle Ajasin University	Akungba Akoko ...
// 11	Federal University of Agriculture, Abeokuta	Abeokuta ...
// 12	Ladoke Akintola University of Technology	Ogbomoso ...
// 13	University of Abuja	Abuja
// 14	Nnamdi Azikiwe University	Awka ...
// 15	Federal University, Oye-Ekiti	Oye-Ekiti ...
// 16	University of Benin	Benin City
// 17	Kwara State University	Ilorin
// 18	University of Jos	Jos
// 20	Federal University of Technology, Owerri	Owerri
// 21	Bayero University Kano	Kano
// 22	Federal University of Technology, Minna	Minna ...
// 24	Federal University of Technology, Akure	Akure
// 25	Osun State University	Oshogbo ...
// 26	Lagos State University	Ojo
// 27	Usmanu Danfodio University	Sokoto
// 28	Federal University, Lokoja	Lokoja
// 29	Alex Ekwueme Federal University	Ikwo
// 30	Moshood Abiola Polytechnic, Abeokuta	Abeokuta
// 31	Rivers State University	Port Harcourt ...
// 32	Ekiti State University, Ado Ekiti	Ado-Ekiti
// 40	Benue State University	Makurdi
// 41	Kaduna State University	Kaduna
// 42	Kano University of Science and Technology	Wudil
// 43	University of Calabar	Calabar
// 44	Abia State University	Uturu
// 45	University of Uyo	Uyo
// 46	Federal University, Lafia	Lafia
// 47	Delta State University, Abraka	Abraka
// 48	Taraba State University	Jalingo
// 49	Enugu State University of Science and Technology	Enugu
// 51	Nasarawa State University	Keffi
// 53	University of Maiduguri	Maiduguri
// 55	Michael Okpara University of Agriculture	Umuahia
// 56	Umaru Musa Yar'Adua University	Katsina
// 57	Chukwuemeka Odumegwu Ojukwu University	Uli ...
// 58	Sokoto State University	Sokoto
// 59	Tai Solarin University of Education	Ijebu-Ode ...
// 60	Yobe State University	Damaturu
// 61	Federal University, Otuoke	Otuoke
// 63	Ebonyi State University	Abakaliki
// 64	Abubakar Tafawa Balewa University	Bauchi
// 66	Ignatius Ajuru University of Education	Port Harcourt
// 67	Imo State University	Owerri
// 68	Federal University, Dutsin-Ma	Dutsin-Ma
// 74	Ibrahim Badamasi Babangida University	Lapai
// 75	Federal University of Petroleum Resources	Effurun
// 76	Joseph Sarwuan Tarkaa University	Makurdi
// 77	University of Cross River State	Calabar ...
// 78	University of Medical Sciences	Ondo City
// 79	Federal University, Dutse	Dutse
// 82	Niger Delta University	Wilberforce Island
// 84	Yusuf Maitama Sule University, Kano	Kano
// 85	Sule Lamido University	Kafin Hausa
// 88	Kogi State University	Anyigba
// 90	Ambrose Alli University	Ekpoma
// 92	Federal University, Birnin Kebbi	Birnin Kebbi
// 95	The Technical University	Ibadan
// 96	Bauchi State University	Gadau ...
// 98	Gombe State University	Gombe
// 100	Edo State University Uzairue	Iyamho
// 101	Federal University, Gusau	Gusau
// 103	Plateau State University	Bokkos
// 106	Akwa Ibom State University	Ikot Akpad ...
// 110	Federal University, Kashere	Kashere
// 111	Modibbo Adama University, Yola	Yola
// 112	University of Africa	Toru-Orua ...
// 119	Federal University, Wukari	Wukari
// 125	Federal University, Gashua	Gashua
// 129	Ondo State University of Science and Technology	Okitipupa
// 131	Adamawa State University	Mubi
// 132	Nigerian Maritime University, Okerenkoko	Okerenghigho
// 133	Kebbi State University of Science and Technology	Aliero
// 156	Kingsley Ozumba Mbadiwe University	Ideato
// 157	Borno State University	Maiduguri

// export const University = [
//   { id: 1, name: "University of Port Harcourt", city: "Port Harcourt" },
//   { id: 2, name: "University of Ibadan", city: "Ibadan" },
//   { id: 3, name: "University of Ilorin", city: "Ilorin" },
//   { id: 4, name: "University of Lagos", city: "Lagos" },
//   { id: 5, name: "Obafemi Awolowo University", city: "Ile-Ife" },
//   { id: 7, name: "University of Nigeria", city: "Nsukka" },
//   { id: 8, name: "Ahmadu Bello University", city: "Zaria" },
//   { id: 9, name: "Olabisi Onabanjo University", city: "Ago Iwoye" },
//   { id: 10, name: "Adekunle Ajasin University", city: "Akure" },
//   {
//     id: 11,
//     name: "Federal University of Agriculture, Abeokuta",
//     city: "Abeokuta",
//   },
//   {
//     id: 12,
//     name: "Ladoke Akintola University of Technology",
//     city: "Ogbomoso",
//   },
//   { id: 13, name: "University of Abuja", city: "Abuja" },
//   { id: 14, name: "Nnamdi Azikiwe University", city: "Akwa Ibom" },
//   { id: 15, name: "Federal University of Technology, Owerri", city: "Owerri" },
//   { id: 16, name: "Bayero University Kano", city: "Kano" },
//   { id: 17, name: "Federal University of Technology, Minna", city: "Minna" },
//   { id: 18, name: "Federal University of Technology, Akure", city: "Akure" },
//   { id: 19, name: "Osun State University", city: "Oshogbo" },
//   { id: 20, name: "Lagos State University", city: "Ojo" },
//   { id: 21, name: "Usmanu Danfodio University", city: "Sokoto" },
//   { id: 22, name: "Federal University, Lokoja", city: "Lokoja" },
//   { id: 23, name: "Alex Ekwueme Federal University", city: "Ikwo" },
//   { id: 24, name: "Moshood Abiola Polytechnic, Abeokuta", city: "Abeokuta" },
//   { id: 25, name: "Rivers State University", city: "Port Harcourt" },
//   { id: 26, name: "Ekiti State University, Ado Ekiti", city: "Ado Ekiti" },
//   { id: 27, name: "Benue State University", city: "Makurdi" },
//   { id: 28, name: "Kaduna State University", city: "Kaduna" },
//   { id: 29, name: "Kano University of Science and Technology", city: "Wudil" },
//   { id: 30, name: "University of Calabar", city: "Calabar" },
//   { id: 31, name: "Abia State University", city: "Uturu" },
//   { id: 32, name: "University of Uyo", city: "Uyo" },
//   { id: 33, name: "Federal University, Lafia", city: "Lafia" },
//   { id: 34, name: "Delta State University, Abraka", city: "Abraka" },
//   { id: 35, name: "Taraba State University", city: "Jalingo" },
//   {
//     id: 36,
//     name: "Enugu State University of Science and Technology",
//     city: "Enugu",
//   },
//   { id: 37, name: "Nasarawa State University", city: "Keffi" },
//   { id: 38, name: "University of Maiduguri", city: "Maiduguri" },
//   { id: 39, name: "Chukwuemeka Odumegwu Ojukwu University", city: "Uliyo" },
//   { id: 40, name: "Sokoto State University", city: "Sokoto" },
//   { id: 41, name: "Tai Solarin University of Education", city: "Ijebu-Ode" },
//   { id: 42, name: "Yobe State University	", city: "Damaturu" },
//   { id: 43, name: "Federal University, Otuoke", city: "Otuoke" },
//   { id: 44, name: "Ebonyi State University", city: "Abakaliki" },
//   { id: 45, name: "Abubakar Tafawa Balewa University", city: "Bauchi" },
//   {
//     id: 46,
//     name: "Ignatius Ajuru University of Education",
//     city: "Port Harcourt",
//   },
//   { id: 47, name: "Imo State University", city: "Owerri" },
//   { id: 48, name: "Federal University, Dutsin-Ma", city: "Dutsin-Ma" },
//   { id: 49, name: "Sule Lamido University", city: "Kafin Hausa" },
//   { id: 50, name: "Kogi State University", city: "kogi" },
//   { id: 51, name: "Ambrose Alli University", city: "Ekpoma" },
//   { id: 52, name: "Federal University, Birnin Kebbi", city: "Birnin Kebbi" },
//   { id: 53, name: "Niger Delta University", city: "Wilberforce Island" },
//   { id: 54, name: "Yusuf Maitama Sule University", city: " Kano" },
//   { id: 55, name: "Sule Lamido University", city: "Kafin Hausa" },
//   { id: 56, name: "Kogi State University", city: "Kogi" },
//   { id: 57, name: "Ambrose Alli University", city: "Ekpoma" },
//   { id: 58, name: "Federal University, Birnin Kebbi", city: "Birnin Kebbi" },
//   { id: 58, name: "The Technical University", city: "Ibadan" },
//   { id: 60, name: "Bauchi State University", city: "Gadau" },
//   { id: 61, name: "Gombe State University", city: "Gombe" },
//   { id: 62, name: "Edo State University Uzairue", city: "Iyamho" },
//   { id: 63, name: "Federal University, Gusau", city: "Gusau" },
//   { id: 65, name: "Plateau State University", city: "Bokkos" },
//   { id: 68, name: "Akwa Ibom State University", city: "Ikot Akpad" },
//   { id: 70, name: "Federal University, Kashere", city: "Kashere" },
//   { id: 71, name: "Modibbo Adama University, Yola", city: "Yola" },
//   { id: 72, name: "University of Africa", city: "Toru-Orua" },
//   { id: 73, name: "Federal University, Wukari", city: "Wukari" },
//   { id: 73, name: "Federal University, Gashua", city: "Gashua" },
//   { id: 74, name: "Federal University, Gashua", city: "Gashua" },
//   {
//     id: 74,
//     name: "Ondo State University of Science and Technology",
//     city: "Okitipupa",
//   },
//   { id: 75, name: "Adamawa State University", city: "Mubi" },
//   { id: 76, name: "Nigerian Maritime University", city: "Okerenkoko" },
//   {
//     id: 77,
//     name: "Kebbi State University of Science and Technology",
//     city: "Aliero",
//   },
//   { id: 78, name: "Kingsley Ozumba Mbadiwe University	Ideato", city: "Ideato" },
//   { id: 78, name: "Borno State University", city: "Maiduguri" },
//   { id: 79, name: "Federal University, Oye-Ekiti", city: "Oye-Ekiti" },
//   { id: 80, name: "University of Benin	", city: "Benin City" },
//   { id: 81, name: "Kwara State University	Ilorin", city: "Ilorin" },
//   { id: 82, name: "University of Jos", city: "Jos" },
// ];

export const University = [
  {
    value: "aau_ambrose_ali_university_ekpoma",
    text: "AAU Ambrose Ali University, Ekpoma",
  },
  { value: "abdul_gusau_polytechnic", text: "Abdul Gusau Polytechnic" },
  { value: "abia_state_polytechnic", text: "Abia State polytechnic" },
  {
    value: "abia_state_university_in_uturu",
    text: "Abia State University in Uturu",
  },
  {
    value: "abraham_adesanya_polytechnic",
    text: "Abraham Adesanya Polytechnic",
  },
  {
    value: "abu_ahmadu_bello_university_zaria",
    text: "ABU Ahmadu Bello University, Zaria",
  },
  {
    value: "abubakar_tafawa_balewa_university",
    text: "Abubakar Tafawa Balewa University",
  },
  { value: "achievers_university", text: "Achievers University" },
  {
    value: "acu_ajayi_crowther_university_oyo",
    text: "ACU Ajayi Crowther University, Oyo",
  },
  {
    value: "adamawa_state_polytechnic_yola",
    text: "Adamawa State polytechnic, Yola",
  },
  {
    value: "adamawa_state_university_mubi",
    text: "Adamawa State University, Mubi",
  },
  {
    value: "adamu_augie_college_of_education_argungu",
    text: "Adamu Augie College of Education, Argungu",
  },
  { value: "adekunle_ajasin_university", text: "Adekunle Ajasin University" },
  { value: "adeleke_university_ede", text: "Adeleke University, Ede" },
  {
    value: "adeniran_ogunsanya_college_of_education",
    text: "Adeniran Ogunsanya College Of Education",
  },
  {
    value: "adeyemi_college_of_education_ondo",
    text: "Adeyemi College of Education, Ondo.",
  },
  {
    value: "administrative_staff_college_of_nigeria__badagry",
    text: "Administrative Staff College of Nigeria  Badagry",
  },
  { value: "aeroland_aviation_school", text: "Aeroland Aviation School" },
  { value: "afe_babalola_university", text: "Afe Babalola University" },
  {
    value: "african_institute_of_science_and_technology",
    text: "African Institute Of Science And Technology",
  },
  { value: "african_maritime_academy", text: "African Maritime Academy" },
  {
    value: "african_university_of_science_and_technology",
    text: "African University of Science and Technology",
  },
  {
    value: "air_force_institute_of_technology",
    text: "Air Force Institute Of Technology",
  },
  {
    value: "akanu_ibiam_federal_polytechnic_unwana",
    text: "Akanu Ibiam Federal Polytechnic, Unwana",
  },
  {
    value: "akperan_orshi_college_of_agriculture_yandev",
    text: "Akperan Orshi college of Agriculture Yandev",
  },
  {
    value: "akwa_ibom_state_college_of_education_afaha_nsit",
    text: "Akwa Ibom State College of Education, Afaha Nsit",
  },
  { value: "akwa_ibom_state_polytechnic", text: "Akwa Ibom State Polytechnic" },
  { value: "akwa_ibom_state_university_", text: "Akwa Ibom State University" },
  { value: "allover_central_polytechnic", text: "Allover Central Polytechnic" },
  {
    value: "alv_alvan_ikoku_college_of_education_owerri",
    text: "ALV Alvan Ikoku College Of Education, Owerri",
  },
  { value: "amec_college", text: "AMEC college" },
  {
    value: "ameer_shehu_idris_college_of_advanced_studies_zaria",
    text: "Ameer Shehu Idris College of Advanced Studies, Zaria",
  },
  {
    value: "aminu_kano_college_of_islamic_and_legal_studies",
    text: "Aminu Kano College of Islamic And Legal Studies",
  },
  {
    value: "anambra_state_university_anambra",
    text: "Anambra State University, Anambra",
  },
  { value: "anchor_university_lagos", text: "Anchor University, Laogs" },
  { value: "apex_polytechnic", text: "Apex Polytechnic" },
  { value: "aptech", text: "Aptech" },
  {
    value: "association_of_national_accountants_of_nigeria_",
    text: "Association of National Accountants of Nigeria",
  },
  { value: "babcock_university", text: "Babcock University" },
  {
    value: "bamidele_olumilua_university_of_education_science_and_technology",
    text: "Bamidele Olumilua University of Education, Science and Technology, Ikere-Ekiti",
  },
  { value: "baptist_school_of_nursing", text: "Baptist School of Nursing" },
  { value: "bay_bayero_university_kano", text: "BAY Bayero University, Kano" },
  {
    value: "bayelsa_medical_university_yenagoa",
    text: "Bayelsa Medical University, Yenagoa",
  },

  {
    value: "bayelsa_state_college_of_health_technology",
    text: "Bayelsa State College of Health Technology",
  },
  {
    value: "bells_univ_of_tech_badagry_badagry",
    text: "Bells Univ. Of Tech. Badagry, Badagry",
  },
  {
    value: "bells_university_of_technology",
    text: "Bells University of Technology",
  },
  {
    value: "ben_university_of_benin_benin",
    text: "BEN University Of Benin, Benin",
  },
  {
    value: "bendel_state_university_ekpoma",
    text: "Bendel State University, Ekpoma",
  },
  {
    value: "benin_technical_college_benin_city",
    text: "Benin Technical College, Benin City",
  },
  {
    value: "benue_state_polytechnic_ugbokolo",
    text: "Benue State Polytechnic, Ugbokolo",
  },
  {
    value: "benue_state_university_makurdi",
    text: "Benue State University, Makurdi",
  },
  {
    value: "best_legacy_college_of_education_ogbomoso",
    text: "Best Legacy College of Education, Ogbomoso",
  },
  {
    value: "bin_gham_university_new_karu",
    text: "BIN Gham University, New Karu",
  },
  { value: "bingham_university_karu", text: "Bingham University, Karu" },
  {
    value: "biu_benson_idahosa_university_benin_city",
    text: "BIU Benson Idahosa University, Benin City",
  },
  {
    value: "bouyeat_computer_training_school",
    text: "Bouyeat Computer Training School",
  },
  { value: "bowen_university_iwo", text: "Bowen University, Iwo" },
  {
    value: "british_career_training_college",
    text: "British Career Training College",
  },
  {
    value: "buka_abba_ibrahim_university_damaturu",
    text: "Buka Abba Ibrahim University, Damaturu",
  },
  { value: "caleb_university_lagos", text: "Caleb University, Lagos" },
  {
    value: "caritas_university_amorji-nike",
    text: "Caritas University, Amorji-Nike",
  },
  {
    value: "cem_college_of_education_minna",
    text: "CEM College Of Education, Minna",
  },
  {
    value: "certified_institute_of_shipping_of_nigeria",
    text: "Certified Institute of Shipping of Nigeria",
  },
  {
    value: "chartered_institute_of_administration",
    text: "Chartered Institute of Administration",
  },
  {
    value: "chartered_institute_of_marketing_of_nigeria",
    text: "Chartered Institute of Marketing of Nigeria",
  },
  {
    value: "chartered_institute_of_purchasing_and_supply_management",
    text: "Chartered Institute of Purchasing and Supply Management",
  },
  {
    value: "christwealth_university_ifewara",
    text: "Christwealth University ifewara",
  },
  {
    value: "claretian_institute_of_philosophy_maryland_nekede",
    text: "Claretian Institute of Philosophy, Maryland Nekede",
  },
  {
    value: "college_for_legal_and_general_studies_minna",
    text: "College for Legal and General Studies, Minna",
  },
  {
    value: "college_of_administrative_and_business_studies_bida",
    text: "College of Administrative and Business Studies, Bida",
  },
  {
    value: "college_of_administrative_and_business_studies_kumo",
    text: "College of Administrative and Business Studies, Kumo",
  },
  {
    value: "college_of_administrative_and_business_studies_potiskum",
    text: "College of Administrative and Business Studies, Potiskum",
  },
  {
    value: "college_of_agriculture_lafia",
    text: "College of Agriculture, Lafia",
  },
  {
    value: "college_of_arabic_and_islamic_studiesrikkos",
    text: "College of Arabic and Islamic StudiesRikkos",
  },
  {
    value: "college_of_art_science_and_remedial_studies",
    text: "College of Art, Science and Remedial Studies",
  },
  {
    value: "college_of_arts_&_sciences_nnung_ukim",
    text: "College of Arts & Sciences, Nnung Ukim",
  },
  {
    value: "college_of_arts_and_islamic_legal_studies",
    text: "College of Arts and Islamic Legal Studies",
  },
  {
    value: "college_of_arts_and_science_ile_ife",
    text: "College of Arts and Science, Ile Ife",
  },
  {
    value: "college_of_arts_science_and_technology_kurgwi",
    text: "College of Arts, Science and Technology, Kurgwi",
  },
  {
    value: "college_of_aviation_and_management_studies",
    text: "College Of Aviation And Management Studies",
  },
  {
    value: "college_of_business_and_legal_studies",
    text: "College of Business and Legal Studies",
  },
  { value: "college_of_education_agbor", text: "College of Education, Agbor" },
  {
    value: "college_of_education_akwanga",
    text: "College of Education, Akwanga",
  },
  { value: "college_of_education_azare", text: "College of Education - Azare" },
  { value: "college_of_education_benin", text: "College of Education Benin" },
  {
    value: "college_of_education_gashua",
    text: "College of Education, Gashua",
  },
  { value: "college_of_education_jos", text: "College of Education, Jos" },
  {
    value: "college_of_education_kastina_ala",
    text: "College of Education Kastina Ala.",
  },
  { value: "college_of_education_oju", text: "College of Education Oju" },
  {
    value: "college_of_education_port-harcourt",
    text: "College Of Education, Port-Harcourt",
  },
  {
    value: "college_of_education_waka-biu",
    text: "College of Education Waka-Biu",
  },
  { value: "college_of_education_warri", text: "College of Education, Warri" },
  {
    value: "college_of_educationikere-ekiti",
    text: "College of Education,Ikere-Ekiti",
  },
  {
    value: "college_of_health_science_and_technology_amaigbo_nwangele",
    text: "College of Health Science and Technology, Amaigbo, Nwangele",
  },
  { value: "college_of_health_sciences", text: "College of Health Sciences" },
  {
    value: "college_of_health_sciences_aba",
    text: "College of Health Sciences Aba",
  },
  {
    value: "college_of_health_technology_iboko_okpoma_yala",
    text: "College of Health Technology, Iboko, Okpoma, Yala",
  },
  {
    value: "college_of_health_technology_zawan",
    text: "College of Health Technology, Zawan",
  },
  {
    value: "college_of_immaculate_conception",
    text: "College of Immaculate Conception",
  },
  {
    value: "college_of_islamic_science_gusau",
    text: "College of Islamic Science, Gusau",
  },
  { value: "college_of_nursing_ilorin", text: "College of Nursing, Ilorin" },
  {
    value: "college_of_physical_education_mosogar",
    text: "College of Physical Education, Mosogar",
  },
  {
    value: "college_of_nursing_sciences_st_camillus",
    text: "College of Nursing Sciences St. Camillus Catholic Hospital, Uromi, Edo state.)",
  },
  { value: "convenant_university", text: "Convenant University" },
  {
    value: "command_day_secondary_school_ojo",
    text: "Command Day Secondary School, Ojo",
  },
  { value: "computer_training_institute", text: "Computer Training Institute" },
  {
    value: "conarina_school_of_maritime_&_transport_technology_oria-abraka",
    text: "Conarina School of Maritime & Transport Technology, Oria-Abraka",
  },
  { value: "covenant_polytechnic_aba", text: "Covenant Polytechnic, Aba" },
  {
    value: "cra_crawford_university_igbesa",
    text: "CRA Crawford University, Igbesa",
  },
  {
    value: "crescent_university_abeokuta",
    text: "Crescent University, Abeokuta",
  },
  {
    value: "cross_river_state_college_of_education_akamkpa",
    text: "Cross River State College of Education, akamkpa",
  },
  {
    value: "cross_river_state_university_of_technology_calabar",
    text: "Cross River State University of Technology, Calabar",
  },
  { value: "crown_polytechnic_ado_ekiti", text: "Crown Polytechnic Ado Ekiti" },
  {
    value: "dalewares_institute_of_technology",
    text: "Dalewares Institute of Technology",
  },
  {
    value: "delta_state_polytechnic_ogwashi-uku",
    text: "Delta State Polytechnic, Ogwashi-Uku",
  },
  {
    value: "delta_state_polytechnic_otefe-oghara",
    text: "Delta State Polytechnic, Otefe-Oghara",
  },
  {
    value: "delta_state_polytechnic_ozoro",
    text: "Delta State Polytechnic, Ozoro",
  },
  {
    value: "delta_state_school_of_marine_technology_burutu",
    text: "Delta State School of Marine Technology, Burutu",
  },
  { value: "delta_state_university_", text: "Delta State University" },
  { value: "dialogue_computer_institute", text: "Dialogue Computer Institute" },
  {
    value: "divisional_teacher's_training_college_oye-ekiti",
    text: "Divisional Teacher's Training College, Oye-Ekiti",
  },
  {
    value: "ds_adegbenro_ict_polytechnic_itoro_ewekoro",
    text: "DS Adegbenro Ict Polytechnic, Itoro, Ewekoro",
  },
  { value: "dominion_university_ibadan", text: "Dominion University, Ibadan" },
  {
    value: "ebonyi_state_college_of_education_ikwo_",
    text: "Ebonyi State College of Education Ikwo",
  },
  {
    value: "ebonyi_state_university_abakaliki_",
    text: "Ebonyi State University, Abakaliki",
  },
  { value: "ecwa_school_of_nursing_", text: "ECWA School of Nursing" },
  {
    value: "ecwa_theological_seminary_kagoro",
    text: "ECWA Theological Seminary Kagoro",
  },
  {
    value: "edo_state_institute_of_technology_and_management_usen",
    text: "Edo State Institute of Technology and Management Usen",
  },
  { value: "eha-amufucaritas_university", text: "Eha-AmufuCaritas University" },
  { value: "eku_edwin_clark_university", text: "Eku Edwin Clark University" },
  { value: "eku_edwin_clark_university", text: "Eku Edwin Clark University" },
  { value: "elizade_university", text: "Elizade University" },
  {
    value: "eko_university_of_medicine_and_health_science",
    text: "Eko University of Medicine and Health Science",
  },
  {
    value: "enugu_state_college_of_education_technical_enugu",
    text: "Enugu State College of Education Technical, Enugu",
  },
  {
    value: "ekiti_state_college_of_health_sciences_and_technology_ijero",
    text: "Ekiti State College of Health Sciences and Technology, Ijero",
  },
  { value: "ekiti_state_university", text: "Ekiti State University" },
  { value: "excel_college", text: "Excel College" },
  { value: "ezekiel_private_college", text: "Ezekiel Private College" },
  {
    value: "ezzamgbo_and_federal_college_of_agriculture_ishiagu",
    text: "Ezzamgbo and Federal College of Agriculture, Ishiagu.",
  },
  {
    value: "fantsuam_foundation_kafanchan",
    text: "Fantsuam Foundation, Kafanchan",
  },
  {
    value: "federal_college_of_agriculture_moor_plantation_ibadan",
    text: "Federal College of Agriculture, Moor Plantation, Ibadan",
  },
  {
    value: "federal_college_of_animal_production_and_health",
    text: "Federal College Of Animal Production and Health",
  },
  {
    value: "federal_college_of_chemical_and_leather_technology",
    text: "Federal College of Chemical and Leather Technology",
  },
  {
    value: "federal_college_of_education",
    text: "Federal College of Education",
  },
  {
    value: "federal_college_of_education",
    text: "Federal College of Education",
  },
  {
    value: "federal_college_of_education__akoka",
    text: "Federal College of Education , Akoka",
  },
  {
    value: "federal_college_of_education__bichi",
    text: "Federal College of Education , Bichi",
  },
  {
    value: "federal_college_of_education__gombe",
    text: "Federal College of Education  Gombe",
  },
  {
    value: "federal_college_of_education__omoku",
    text: "Federal College of Education , Omoku",
  },
  {
    value: "federal_college_of_education_abeokuta",
    text: "Federal College of Education Abeokuta",
  },
  {
    value: "federal_college_of_education_agasha",
    text: "Federal College of Education Agasha",
  },
  {
    value: "federal_college_of_education_katsina",
    text: "Federal College of Education Katsina",
  },
  {
    value: "federal_college_of_education_kontagora",
    text: "Federal College of Education, Kontagora",
  },
  {
    value: "federal_college_of_education_okene",
    text: "Federal College of Education, Okene",
  },
  {
    value: "federal_college_of_education_pankshin",
    text: "Federal College of Education, Pankshin",
  },
  {
    value: "federal_college_of_education_technical_asaba",
    text: "Federal College of Education Technical, Asaba",
  },
  {
    value: "federal_college_of_education_zaria",
    text: "Federal College Of Education, Zaria",
  },
  {
    value: "federal_college_of_fisheries_and_marine_technology",
    text: "Federal College of Fisheries and Marine Technology",
  },
  { value: "federal_college_of_forestry", text: "Federal College of Forestry" },
  {
    value: "federal_college_of_forestry_mechanization",
    text: "Federal College Of Forestry Mechanization",
  },
  {
    value: "federal_college_of_orthopedic_technology_igbobi",
    text: "Federal College Of Orthopedic Technology, Igbobi",
  },
  {
    value: "federal_college_of_wildlife_management_new_bussa",
    text: "Federal College of Wildlife Management, New Bussa",
  },
  { value: "federal_cooperative_college", text: "Federal Cooperative College" },
  {
    value: "federal_cooperative_college_oji_river_",
    text: "Federal Cooperative College, Oji River",
  },
  {
    value: "federal_polytechnic_ado-ekiti",
    text: "Federal Polytechnic, Ado-Ekiti",
  },
  { value: "federal_polytechnic_auchi", text: "Federal Polytechnic Auchi" },
  { value: "federal_polytechnic_bauchi", text: "Federal Polytechnic, Bauchi" },
  { value: "federal_polytechnic_bida", text: "Federal Polytechnic Bida" },
  {
    value: "federal_polytechnic_damaturu",
    text: "Federal Polytechnic Damaturu",
  },
  { value: "federal_polytechnic_ede", text: "Federal Polytechnic Ede" },
  { value: "federal_polytechnic_ekowe", text: "Federal Polytechnic, Ekowe" },
  { value: "federal_polytechnic_ilaro", text: "Federal Polytechnic Ilaro" },
  {
    value: "federal_polytechnic_kaura_namoda",
    text: "Federal Polytechnic Kaura Namoda",
  },
  {
    value: "federal_polytechnic_nekede_owerri",
    text: "Federal Polytechnic Nekede Owerri",
  },
  { value: "federal_polytechnic_offa", text: "Federal Polytechnic Offa" },
  {
    value: "federal_school_of_arts_and_sciences_victoria_island",
    text: "Federal School of Arts and Sciences, Victoria Island",
  },
  {
    value: "federal_school_of_dental_technology_&_therapy",
    text: "Federal School of Dental Technology & Therapy",
  },
  {
    value: "federal_school_of_occupational_therapy",
    text: "Federal School of Occupational Therapy",
  },
  { value: "federal_school_of_science", text: "Federal School of Science" },
  {
    value: "federal_school_of_statistics",
    text: "Federal School of Statistics",
  },
  {
    value: "federal_science_and_technical_college",
    text: "Federal Science and Technical College",
  },
  {
    value: "federal_science_and_technical_college",
    text: "Federal Science and Technical College",
  },
  {
    value: "federal_science_and_technical_college",
    text: "Federal Science and Technical College",
  },
  { value: "federal_training_centre", text: "Federal Training Centre" },
  {
    value: "federal_training_centre_ikoyi",
    text: "Federal Training Centre, Ikoyi",
  },
  {
    value: "federal_training_centre_maiduguri",
    text: "Federal Training Centre, Maiduguri",
  },
  { value: "federal_university_dutse", text: "Federal University, Dutse" },
  {
    value: "federal_university_dutsin-ma",
    text: "Federal University Dutsin-Ma",
  },
  {
    value: "federal_university_gusau_zamfara_state",
    text: "Federal University Gusau, Zamfara State",
  },
  { value: "federal_university_kashere", text: "Federal University Kashere" },
  {
    value: "federal_university_ndufu_alike_ikwo_",
    text: "Federal University Ndufu Alike Ikwo",
  },
  {
    value: "federal_university_of_agriculture_abeokuta",
    text: "Federal University of Agriculture, Abeokuta (FUNAAB)",
  },
  {
    value: "federal_university_of_agriculture_makurdi",
    text: "Federal University of Agriculture, Makurdi",
  },
  {
    value: "federal_university_of_lokoja",
    text: "Federal University Of Lokoja",
  },
  {
    value: "federal_university_of_maiduguri",
    text: "Federal University of Maiduguri",
  },
  {
    value: "federal_university_of_petroleum_resources_effurun",
    text: "Federal University of Petroleum Resources, Effurun",
  },
  {
    value: "federal_university_of_technology",
    text: "Federal University of Technology",
  },
  {
    value: "federal_university_of_technology_akure",
    text: "Federal University of Technology, Akure",
  },
  {
    value: "federal_university_of_technology_lafia",
    text: "Federal University of Technology, Lafia",
  },
  {
    value: "federal_university_of_technology_minna",
    text: "Federal University of Technology, Minna",
  },
  { value: "federal_university_otueke", text: "Federal University, Otueke" },
  {
    value: "federal_university_oye_ekiti",
    text: "Federal University Oye Ekiti",
  },
  {
    value: "fedpolynas_federal_polytechnic_nasarawa",
    text: "FEDPOLYNAS Federal Polytechnic Nasarawa",
  },
  { value: "fggc_bauchi", text: "FGGC Bauchi" },
  { value: "fidei_polytechnic_gboko", text: "Fidei polytechnic, Gboko" },
  {
    value: "first_immaculate_computer_institute",
    text: "First Immaculate Computer Institute",
  },
  {
    value: "fuo_fountain_university_osogbo",
    text: "FUO Fountain University, Osogbo",
  },
  {
    value: "futo_fed_university_of_technology_owerri",
    text: "FUTO Fed University Of Technology, Owerri",
  },
  { value: "goethe-institut", text: "Goethe-Institut" },
  {
    value: "government_technical_college_ado-ekiti",
    text: "Government Technical College, Ado-Ekiti",
  },
  {
    value: "government_technical_college_ado-soba",
    text: "Government Technical College, Ado-Soba",
  },
  {
    value: "government_technical_college_ikorodu",
    text: "Government Technical College, Ikorodu",
  },
  { value: "grace_polytechnic", text: "Grace Polytechnic" },
  { value: "gralom_computer_institute", text: "Gralom Computer Institute" },
  {
    value: "grano_institute_of_catering_and_hotel_management",
    text: "Grano Institute of Catering and Hotel Management",
  },
  { value: "gregory_university_uturu", text: "Gregory University Uturu" },
  {
    value: "gsu_gombe_state_university_tudun_wada_tudun_wada",
    text: "GSU Gombe State University Tudun Wada, Tudun Wada",
  },
  {
    value: "haliru_binji_college_of_art_and_science",
    text: "Haliru Binji College Of Art and Science",
  },
  { value: "hallmark_university", text: "Hallmark University" },
  {
    value: "hassan_usman_katsina_polytechnic",
    text: "Hassan Usman Katsina Polytechnic",
  },
  {
    value: "helpers_international_college__institute_for_industrial_technology",
    text: "Helpers International College  Institute for Industrial Technology",
  },
  { value: "heritage_polytechnic_eket", text: "Heritage Polytechnic, Eket" },
  {
    value: "hik_al-hikmah_university_ilorin",
    text: "Al-Hikmah University, Ilorin",
  },
  {
    value: "his_mercy_computer_institute_",
    text: "His Mercy Computer Institute",
  },
  {
    value: "hussaini_adamu_federal_polytechnic_kazaure",
    text: "Hussaini Adamu Federal Polytechnic Kazaure",
  },
  {
    value: "ibrahim_babangida_college_of_agriculture_obubra",
    text: "Ibrahim Babangida College of Agriculture, Obubra",
  },
  {
    value: "ifo_college_of_management_and_technology",
    text: "Ifo College of Management and Technology",
  },
  {
    value: "igb_igbinedion_university_okada-benin",
    text: "IGB Igbinedion University, Okada-Benin",
  },
  {
    value: "imo_state_polytechnic_umuagwo",
    text: "Imo State Polytechnic, Umuagwo",
  },
  {
    value: "imo_state_technological_skills_acquisition_institution_orlu",
    text: "Imo State Technological Skills Acquisition Institution, Orlu",
  },
  {
    value: "imsu_imo_state_university_owerri",
    text: "IMSU Imo State University, Owerri",
  },
  {
    value: "informatics_institute_of_information_technology_kazaure",
    text: "informatics Institute of Information Technology, Kazaure",
  },
  {
    value: "innovation_institute_of_technology",
    text: "Innovation Institute of Technology",
  },
  {
    value: "institute_of_chartered_economists_of_nigeria_",
    text: "Institute of Chartered Economists of Nigeria",
  },
  {
    value: "institute_of_continuing_education_auchi",
    text: "Institute of Continuing Education, Auchi",
  },
  {
    value: "institute_of_data_processing_management_",
    text: "Institute of Data Processing Management",
  },
  {
    value: "institute_of_management_and_technology_",
    text: "Institute of Management and Technology",
  },
  {
    value: "institute_of_science_and_technology_yenagoa",
    text: "Institute of Science and Technology Yenagoa",
  },
  {
    value: "institute_of_strategic_management_nigeria",
    text: "Institute of Strategic Management, Nigeria",
  },
  { value: "interlink_polytechnic", text: "Interlink Polytechnic" },
  {
    value: "ipakodo_grammar_school_ikorodu",
    text: "Ipakodo Grammar School, Ikorodu",
  },
  {
    value: "isah_kaita_college_of_education_dutsinma",
    text: "Isah Kaita College of Education Dutsinma",
  },
  {
    value: "jigawa_state_college_of_agriculture_hadejia",
    text: "Jigawa State College Of Agriculture, Hadejia",
  },
  {
    value: "jigawa_state_college_of_education_gumel_dutse",
    text: "Jigawa State College of Education, Gumel, Dutse",
  },
  { value: "jigawa_state_polytechnic", text: "Jigawa State Polytechnic" },
  { value: "jos_university_of_jos_jos", text: "JOS University Of Jos, Jos" },
  {
    value: "joseph_ayo_babalola_university",
    text: "Joseph Ayo Babalola University - JABU",
  },
  {
    value: "kad_kaduna_polytechnic_kaduna",
    text: "KAD Kaduna Polytechnic, Kaduna",
  },
  {
    value: "kaduna_state_college_of_education",
    text: "Kaduna State College of Education",
  },
  {
    value: "kan_federal_college_of_education_kano",
    text: "KAN Federal College Of Education, Kano",
  },
  { value: "kano_state_polytechnic", text: "Kano State Polytechnic" },
  { value: "karrox_ict_institute", text: "karROX ICT Institute" },
  {
    value: "kas_kaduna_state_university_kaduna",
    text: "KAS Kaduna State University, Kaduna",
  },
  { value: "kaura_knamoda_polytechnic", text: "Kaura Knamoda Polytechnic" },
  {
    value: "keme_balogun_college_ibeshe",
    text: "Keme Balogun College, Ibeshe",
  },
  {
    value: "kiagbodo_eagle_heights_university_omadino",
    text: "Kiagbodo Eagle Heights University, Omadino",
  },
  {
    value: "king's_college_of_commerce_buguma",
    text: "King's College of Commerce, Buguma",
  },
  { value: "king's_glory_university", text: "king's Glory University" },
  {
    value: "kogi_state_college_of_education",
    text: "Kogi State College of Education",
  },
  {
    value: "kogi_state_college_of_nursing",
    text: "Kogi State College of Nursing",
  },
  {
    value: "kogi_state_polytechnic_lokoja",
    text: "Kogi State Polytechnic, Lokoja",
  },
  {
    value: "ksu_kogi_state_university_anyigba",
    text: "KSU Kogi State University, Anyigba",
  },
  {
    value: "kts_katsina_state_university_katsina",
    text: "KTS Katsina State University, Katsina",
  },
  {
    value: "kus_kebbi_state_univ_of_science_&_tech_aliero_aliero",
    text: "KUS Kebbi State Univ. Of Science & Tech. Aliero, Aliero",
  },
  {
    value: "kut_kano_university_of_technology_kano",
    text: "KUT Kano University Of Technology, Kano",
  },
  {
    value: "kwara_state_college_of_arabic_and_islamic_legal_studies",
    text: "Kwara State College of Arabic and Islamic Legal Studies",
  },
  {
    value: "kwara_state_college_of_education",
    text: "Kwara State College of Education",
  },
  {
    value: "kwara_state_college_of_health_and_technology",
    text: "Kwara State College of Health and Technology",
  },
  {
    value: "kwara_state_polytechnic_ilorin",
    text: "Kwara State Polytechnic, Ilorin",
  },
  { value: "kwara_state_university_", text: "Kwara State University" },
  {
    value: "ladoke_akintola_university_of_technology_ogbomoso",
    text: "Ladoke Akintola University Of Technology Ogbomoso",
  },
  { value: "lagos_business_school", text: "Lagos Business School" },
  {
    value: "lagos_city_computer_college_",
    text: "Lagos City Computer College",
  },
  {
    value: "lagos_school_of_travels_and_tourism",
    text: "Lagos School of Travels and Tourism",
  },
  {
    value: "lagos_state_college_of_health_technology_yaba",
    text: "Lagos State College of Health Technology, Yaba",
  },
  {
    value: "lagos_state_co-operative_college",
    text: "Lagos State Co-operative College",
  },
  {
    value: "lagos_state_university_of_science_and_technology",
    text: "Lagos State University of Science and Technology (LASUSTECH)",
  },
  {
    value: "lagos_state_university_college_of_medicine",
    text: "Lagos State University College of Medicine (LASUCOM)",
  },
  { value: "lagos_state_polytechnic", text: "Lagos state polytechnic" },
  {
    value: "lagos_university_teaching_hospital",
    text: "Lagos University Teaching Hospital",
  },
  {
    value: "landmark_university_omu-aran",
    text: "Landmark university, omu-aran",
  },
  {
    value: "lasu_lagos_state_university_ojo_lagos",
    text: "LASU - Lagos State University, Ojo Lagos",
  },
  {
    value: "lagos_state_college_of_nursing_igando",
    text: "Lagos State College of Nursing, Igando",
  },
  {
    value: "lagos_state_university_of_education_lasued",
    text: "Lagos State University of Education (LASUED)",
  },
  {
    value: "lead_city_university_ibadan",
    text: "Lead City University, Ibadan",
  },
  {
    value: "life_theological_seminary_ikorodu",
    text: "LIFE Theological Seminary, Ikorodu,",
  },
  {
    value: "lighthouse_polytechnic_evbuobanosa",
    text: "Lighthouse Polytechnic, Evbuobanosa",
  },
  { value: "logos_institute_maryland", text: "Logos Institute, Maryland" },
  { value: "lys_children_school", text: "Lys Children School" },
  { value: "madonna_university", text: "Madonna University" },
  { value: "mcpherson_university", text: "McPherson University" },
  {
    value: "mai_university_of_maiduguri_maiduguri",
    text: "MAI University Of Maiduguri, Maiduguri",
  },
  {
    value: "maritime_academy_of_nigeria_oron",
    text: "Maritime Academy of Nigeria, Oron",
  },
  {
    value: "mcadolph_institute_of_information_technology",
    text: "McAdolph Institute Of Information Technology",
  },
  {
    value: "michael_okpara_university_of_agriculture_at_umudike",
    text: "Michael Okpara University of Agriculture at Umudike",
  },
  {
    value: "michael_otedola_college_of_primary_education",
    text: "Michael Otedola College of Primary Education",
  },
  {
    value: "min_fed_university_of_technology_minna",
    text: "MIN Fed University Of Technology, Minna",
  },
  {
    value: "miracle_invasion_leadership_institute",
    text: "Miracle Invasion Leadership Institute",
  },
  {
    value: "moshood_abiola_polytechnic_ojere_abeokuta",
    text: "Moshood Abiola Polytechnic, Ojere, Abeokuta",
  },
  { value: "mountain_top_university", text: "Mountain Top University" },
  {
    value: "mufutau_lanihun_college_of_education_ibadan",
    text: "Mufutau Lanihun College of Education, Ibadan",
  },
  { value: "nacabs_polytechnic_akwanga", text: "Nacabs Polytechnic, Akwanga" },
  {
    value: "nasarawa_state_polytechnic_lafia",
    text: "Nasarawa State Polytechnic, Lafia",
  },
  {
    value: "national_horticultural_research_institute_ibadan",
    text: "National Horticultural Research Institute, Ibadan",
  },
  {
    value: "national_open_university_bauchi",
    text: "National Open University Bauchi",
  },
  {
    value: "national_open_university_of_nigeria",
    text: "National Open University of Nigeria",
  },
  {
    value: "national_open_university_of_nigeria_asaba_study_center_asaba",
    text: "National Open University of Nigeria, Asaba Study Center, Asaba",
  },
  {
    value: "national_open_university_of_nigeria_kaduna",
    text: "National Open University of Nigeria, Kaduna",
  },
  {
    value: "national_teacher's_institute",
    text: "National Teacher's Institute",
  },
  { value: "niger_delta_university", text: "Niger Delta University" },
  {
    value: "niger_state_college_of_nursing_bida",
    text: "Niger State College of Nursing, Bida",
  },
  {
    value: "niger_state_polytechnic_zungeru",
    text: "Niger State Polytechnic, Zungeru",
  },
  {
    value: "nigerian_army_school_of_finance_and_administration_",
    text: "Nigerian Army School Of Finance And Administration",
  },
  {
    value: "nigerian_army_school_of_medical_sciences",
    text: "Nigerian Army School Of Medical Sciences",
  },
  {
    value: "nigerian_army_school_of_nursing_and_midwifery",
    text: "Nigerian Army School of Nursing and Midwifery",
  },
  {
    value: "nigerian_army_university_biu",
    text: "Nigerian Army University, Biu",
  },
  {
    value: "nigerian_college_of_accountancy_jos",
    text: "Nigerian College of Accountancy, Jos",
  },
  {
    value: "nigerian_college_of_aviation_technology_zaria",
    text: "Nigerian College Of Aviation Technology, Zaria",
  },
  {
    value: "nigerian_defence_academy_kaduna",
    text: "Nigerian Defence Academy, Kaduna",
  },
  {
    value: "nigerian_institute_of_computer_science_and_professional_studies",
    text: "Nigerian Institute Of Computer Science And Professional Studies",
  },
  {
    value:
      "nigerian_institute_of_journalism__nigerian_institute_of_management_",
    text: "Nigerian Institute of Journalism  Nigerian Institute Of Management",
  },
  {
    value: "nigerian_institute_of_leather_and_science_technology_samuru",
    text: "Nigerian Institute of Leather and Science Technology, Samuru",
  },
  {
    value: "nigerian_institute_of_safety_professionals_ikotun",
    text: "Nigerian Institute of Safety Professionals, Ikotun",
  },
  {
    value: "nigerian_institute_of_transport_technology",
    text: "Nigerian Institute of Transport Technology",
  },
  // { value: "nigerian_law_school", text: "Nigerian Law School" },
  {
    text: "Nigerian Law School Lagos Campus",
    value: "nigerian-law-school-lagos-campus",
  },
  {
    text: "Nigerian Law School Abuja Campus",
    value: "nigerian-law-school-abuja-campus",
  },
  {
    text: "Nigerian Law School Enugu Campus",
    value: "nigerian-law-school-enugu-campus",
  },
  {
    text: "Nigerian Law School Kano Campus",
    value: "nigerian-law-school-kano-campus",
  },
  {
    text: "Nigerian Law School Yola Campus",
    value: "nigerian-law-school-yola-campus",
  },
  {
    text: "Nigerian Law School Bayelsa Campus",
    value: "nigerian-law-school-bayelsa-campus",
  },
  {
    text: "Nigerian Law School Port Harcourt Campus",
    value: "nigerian-law-school-port-harcourt-campus",
  },
  {
    text: "Nigerian Law School Kabba Campus",
    value: "nigerian-law-school-kabba-campus",
  },
  {
    text: "Nigerian Law School Jos Campus",
    value: "nigerian-law-school-jos-campus",
  },
  {
    text: "Nigerian Law School Maiduguri Campus",
    value: "nigerian-law-school-maiduguri-campus",
  },
  {
    text: "Nigerian Law School Argungu Campus",
    value: "nigerian-law-school-argungu-campus",
  },
  {
    text: "Nigerian Law School Okija Campus",
    value: "nigerian-law-school-okija-campus",
  },
  {
    text: "Nigerian Law School Orogun Campus",
    value: "nigerian-law-school-orogun-campus",
  },

  {
    value: "nigerian_maritime_university_okerenkoko_warri",
    text: "Nigerian Maritime University, Okerenkoko, Warri",
  },
  {
    value: "nigerian_opportunity_industrialization_centre_gbagada",
    text: "Nigerian Opportunity Industrialization Centre, Gbagada",
  },
  {
    value: "nigerian_police_academy_wudil",
    text: "Nigerian Police Academy, Wudil",
  },
  {
    value: "nigerian_turkish_nile_university",
    text: "Nigerian Turkish Nile University",
  },
  {
    value: "niit_national_institute_of_information_technology",
    text: "NIIT National Institute of Information Technology",
  },
  { value: "nnamdi_azikiwe_university", text: "Nnamdi Azikiwe University" },
  {
    value: "novena_university_ogume-amai",
    text: "Novena University, Ogume-Amai",
  },
  {
    value: "nsu_nasarawa_state_university_keffi",
    text: "NSU Nasarawa State University, Keffi",
  },
  {
    value: "nuhu_bamalli_polytechnic_zaria",
    text: "Nuhu Bamalli Polytechnic Zaria",
  },
  {
    value: "nwafor_orizu_university_of_education",
    text: "Nwafor Orizu University of Education",
  },
  {
    value: "oau_obafemi_awolowo_university_ile-ife",
    text: "OAU Obafemi Awolowo University, Ile-Ife",
  },
  {
    value: "obafemi_awolowo_university_staff_school_ife",
    text: "Obafemi Awolowo University Staff School, Ife",
  },
  {
    value: "obong_university_obong_ntak_inyang",
    text: "Obong University, Obong Ntak Inyang",
  },
  { value: "oduduwa_university", text: "Oduduwa University" },
  {
    value: "ogun_state_college_of_health_technology",
    text: "Ogun State College Of Health Technology",
  },
  {
    value: "ondo_state_university_of_science_and_technology",
    text: "Ondo State University of Science and Technology",
  },
  {
    value: "oou_olabisi_onabanjo_university_ago-iwoye",
    text: "OOU Olabisi Onabanjo University, Ago-Iwoye",
  },
  {
    value: "osc_osun_state_college_of_education_ilesa_ilesa",
    text: "OSC Osun State College Of Education Ilesa, Ilesa",
  },
  {
    value: "oss_college_of_education_ila-orangun",
    text: "OSS college of EDucation, Ila-Orangun",
  },
  {
    value: "osun_state_college_of_technolgy_esa_oke",
    text: "Osun State College of Technolgy, Esa oke",
  },
  {
    value: "osun_state_polytechnic_iree",
    text: "Osun State Polytechnic, Iree",
  },
  {
    value: "osun_state_university_osogbo",
    text: "Osun State University, Osogbo",
  },
  {
    value: "our_saviour_institute_of_science_and_technology_enugu",
    text: "Our Saviour Institute of Science and Technology, Enugu",
  },
  {
    value: "oyo_stae_college_of_education",
    text: "Oyo Stae College of Education",
  },
  {
    value:
      "pefti_film_institute__portfolio_and_debt_management_institute_of_nigeria",
    text: "PEFTI Film Institute  Portfolio And Debt Management Institute Of Nigeria",
  },
  {
    value: "petroleum_training_institute_effurun",
    text: "Petroleum Training Institute, Effurun",
  },
  { value: "plateau_state_polytechnic", text: "Plateau State Polytechnic" },
  {
    value: "psu_plateau_state_university_bokkos",
    text: "PSU Plateau State University, Bokkos",
  },
  { value: "ramat_polytechnic_maiduguri", text: "Ramat Polytechnic Maiduguri" },
  { value: "redeemers_university", text: "Redeemers University" },
  {
    value: "renaissance_university_ugbawka",
    text: "Renaissance University, Ugbawka",
  },
  { value: "rhema_university", text: "Rhema University" },
  { value: "ritman_university", text: "Ritman University" },
  {
    value: "rivers_state_college_of_arts",
    text: "Rivers State College Of Arts",
  },
  {
    value: "rivers_state_college_of_health_science_and_technology",
    text: "Rivers State College of Health Science and Technology",
  },
  { value: "rivers_state_polytechnic", text: "Rivers State polytechnic" },
  {
    value: "rivers_state_university_of_technology_port-harcourt",
    text: "Rivers State University Of Technology, Port-Harcourt",
  },
  { value: "ronik_polytechnic", text: "Ronik Polytechnic" },
  { value: "rufus_giwa_polytechnic", text: "Rufus Giwa Polytechnic" },
  {
    value: "sa'adatu_rimi_college_of_education_kumbotso",
    text: "Sa'adatu Rimi College Of Education, Kumbotso",
  },
  {
    value: "saint_finbarr's_college_akoka",
    text: "Saint Finbarr's College, Akoka",
  },
  { value: "salem_university_lokoja", text: "Salem University, Lokoja" },
  {
    value: "samuel_adegboyega_university_ogwa",
    text: "Samuel Adegboyega University, Ogwa",
  },
  {
    value: "sapele_nigerian_navy_maritime_university_ibusa",
    text: "Sapele Nigerian Navy Maritime University, Ibusa",
  },
  {
    value: "savannah_college_of_art_and_design",
    text: "Savannah College of Art and Design",
  },
  {
    value: "school_of_basic_and_remedial_studies_funtua",
    text: "School of Basic and Remedial Studies Funtua",
  },
  { value: "school_of_basic_studies", text: "School Of Basic Studies" },
  {
    value: "school_of_health_and_technology_maiduguri",
    text: "School of Health and Technology, Maiduguri",
  },
  { value: "school_of_health_technology", text: "School of Health Technology" },
  {
    value: "school_of_health_technology_daura",
    text: "School of Health Technology Daura",
  },
  {
    value: "school_of_health_technology_kankia",
    text: "School of Health Technology Kankia",
  },
  {
    value: "school_of_health_technology_makarfi",
    text: "School Of Health Technology, Makarfi",
  },
  {
    value: "school_of_health_technology_ughelli",
    text: "School of Health Technology, Ughelli",
  },
  {
    value: "school_of_midwifery_malumfashi",
    text: "School of Midwifery Malumfashi",
  },
  { value: "school_of_nursing", text: "School of Nursing" },
  { value: "school_of_nursing_agbor", text: "School of Nursing, Agbor" },
  {
    value: "school_of_nursing_and_midwifery",
    text: "School Of Nursing and Midwifery",
  },
  {
    value: "school_of_nursing_imo_state",
    text: "School of Nursing, Imo State",
  },
  { value: "school_of_nursing_katsina", text: "School of Nursing Katsina" },
  {
    value: "school_of_nursing_uyo_eket_oron_ikot_ekpene_etinan",
    text: "School of Nursing Uyo, Eket, Oron, Ikot Ekpene, Etinan",
  },
  { value: "school_of_nursing_warri", text: "School of Nursing, Warri" },
  {
    value: "seminary_of_all_saints_uhiele_ekpoma_",
    text: "Seminary of All Saints, Uhiele, Ekpoma",
  },
  {
    value: "shaka_polytechnic_benin_city",
    text: "Shaka Polytechnic, Benin City",
  },
  { value: "sokoto_state_polytechnic", text: "Sokoto State Polytechnic" },
  { value: "sokoto_state_university", text: "Sokoto State University" },
  { value: "sokoto_teachers'_college", text: "Sokoto Teachers' College" },
  {
    value: "st_andrews_college_of_education_oyo",
    text: "St. Andrews College Of Education, Oyo",
  },
  {
    value: "st_gerard's_school_of_nursing_kakuri",
    text: "St. Gerard's School of Nursing, Kakuri",
  },
  {
    value: "st_luke_anglican_school_of_nursing_wusasa_zaria",
    text: "St. Luke Anglican School of Nursing, Wusasa, Zaria",
  },
  { value: "st_paul's_university_awka", text: "St Paul's University, Awka" },
  {
    value: "st_winifred_innovative_polytechnic_ibadan",
    text: "St. Winifred Innovative Polytechnic, Ibadan",
  },
  {
    value: "state_school_of_midwifery_asaba",
    text: "State School of Midwifery, Asaba",
  },
  {
    value: "state_school_of_nursing_sapele_road_benin_city",
    text: "State School of Nursing, Sapele Road, Benin City",
  },
  {
    value: "suleiman_barau_technical_college_suleja",
    text: "Suleiman Barau Technical College, Suleja",
  },
  {
    value: "summit_university_offa",
    text: "Summit University, Offa",
  },
  { value: "sure_polytechnic_ukanafun", text: "Sure Polytechnic, Ukanafun" },
  {
    value: "tai_solarin_university_of_education_ijebu-ode",
    text: "Tai Solarin University Of Education, Ijebu-Ode",
  },
  {
    value: "tar_taraba_state_university_jalingo",
    text: "TAR Taraba State University, Jalingo",
  },
  {
    value: "taraba_state_college_of_agriculture_jalingo",
    text: "Taraba State College of Agriculture, Jalingo",
  },
  {
    value: "taraba_state_polytechnic_jalingo",
    text: "Taraba State Polytechnic, Jalingo",
  },
  {
    value: "taraba_state_polytechnic_jalingo",
    text: "Taraba State Polytechnic, Jalingo",
  },
  { value: "technical_college_ugep", text: "Technical college Ugep" },
  {
    value: "temple_gate_polytechnic_abayi",
    text: "Temple Gate Polytechnic, Abayi",
  },
  {
    value: "the_chartered_institute_of_bankers_of_nigeria",
    text: "The Chartered Institute of Bankers of Nigeria",
  },
  {
    value: "the_federal_college_of_chemical_and_leather_technology_zaria",
    text: "The Federal College of Chemical and Leather Technology, Zaria",
  },
  {
    value: "the_federal_college_of_education",
    text: "the Federal College of Education",
  },
  {
    value: "the_federal_polytechnic_idah",
    text: "The Federal Polytechnic, Idah",
  },
  {
    value: "the_federal_polytechnic_oko",
    text: "the Federal Polytechnic, Oko",
  },
  { value: "the_gateway_polytechnic", text: "The Gateway Polytechnic" },
  {
    value: "the_institute_of_chartered_accountants_of_nigeria",
    text: "The Institute of Chartered Accountants of Nigeria",
  },
  {
    value: "the_nigerian_institute_of_public_relations",
    text: "The Nigerian Institute Of Public Relations",
  },
  { value: "the_polytechnic_ibadan", text: "The Polytechnic, Ibadan" },
  { value: "the_polytechnic_ibadan", text: "The Polytechnic, Ibadan" },
  { value: "the_polytechnic_ile-ife", text: "The Polytechnic, Ile-Ife" },
  {
    value: "the_tansian_university_umunya",
    text: "The Tansian University, Umunya",
  },
  {
    value: "times_journalism_institute_surulere",
    text: "Times Journalism Institute, Surulere",
  },
  { value: "tower_polytechnic_ibadan", text: "Tower Polytechnic, Ibadan" },
  { value: "trinity_university_yaba", text: "Trinity University Yaba" },
  {
    value: "uaa_university_of_agriculture_abeokuta",
    text: "UAA University Of Agriculture, Abeokuta",
  },
  {
    value: "uad_university_of_ado-ekiti_ado-ekiti",
    text: "UAD University Of Ado-Ekiti, Ado-Ekiti",
  },
  {
    value: "udu_usmanu_danfodio_university_sokoto",
    text: "UDU Usmanu Danfodio University, Sokoto",
  },
  {
    value: "umaru_musa_yaradua_university",
    text: "Umaru Musa Yaradua University",
  },
  {
    value: "universal_college_of_technology_ile-ife",
    text: "Universal College of Technology Ile-ife",
  },
  { value: "university_of_abu", text: "University of Abu" },
  { value: "university_of_calabar", text: "University of Calabar" },
  {
    value: "university_of_ibadan_ibadan",
    text: "University Of Ibadan, Ibadan",
  },
  {
    value: "ilo_university_of_ilorin_ilorin",
    text: "University Of Ilorin, Ilorin",
  },
  {
    value: "university_of_information_and_communication_technology_agbor",
    text: "University of Information and Communication Technology, Agbor",
  },
  { value: "university_of_lagos_lagos", text: "University Of Lagos, Lagos" },
  {
    value: "university_of_medical_sciences_ondo",
    text: "University of Medical Sciences, Ondo",
  },
  {
    value: "university_of_mkar_mkar_gboko",
    text: "University of Mkar, Mkar, Gboko.",
  },
  {
    value: "university_of_nigeria_nsukka",
    text: "University of Nigeria, Nsukka",
  },
  {
    value: "university_of_port-harcourt_port-harcourt",
    text: "University Of Port-Harcourt, Port-Harcourt",
  },
  {
    value: "university_of_science_and_technology_diobu_port_harcourt",
    text: "University of Science and Technology, Diobu, Port Harcourt",
  },
  {
    value: "university_of_science_and_technology_ifaki",
    text: "University Of Science And Technology, Ifaki",
  },
  { value: "university_of_uyo", text: "University of Uyo" },
  { value: "usen_polytechnic", text: "Usen Polytechnic" },
  {
    value: "usmanu_danfodiyo_university_teaching_hospital_school_of_nursing_",
    text: "Usmanu Danfodiyo University Teaching Hospital School Of Nursing",
  },
  { value: "uyo_city_polytechnic", text: "Uyo City Polytechnic" },
  {
    value: "valley_view_polytechnic_aba",
    text: "Valley View Polytechnic, Aba",
  },
  { value: "warri_nigerian_naval_school", text: "Warri Nigerian Naval School" },
  {
    value: "waziri_umaru_federal_polytechnic",
    text: "Waziri Umaru Federal Polytechnic",
  },
  {
    value: "wellspring_university_benin_city",
    text: "Wellspring University, Benin City",
  },
  {
    value: "wesley_university_of_science_and_technology",
    text: "Wesley University of Science and Technology",
  },
  {
    value: "western_delta_university_oghara",
    text: "Western Delta University, Oghara",
  },
  { value: "wolex_polytechnic", text: "Wolex Polytechnic" },
  {
    value: "world_outreach_bible_college",
    text: "World Outreach Bible College",
  },
  {
    value: "yab_yaba_college_of_technology_yaba_lagos",
    text: "YAB Yaba College Of Technology, Yaba, Lagos",
  },
  {
    value: "yaba_speedway_information_technology_institute",
    text: "Yaba Speedway Information Technology Institute",
  },
  {
    value: "ybu_college_of_legal_and_general_studies_daura",
    text: "YBU College of Legal and General Studies Daura",
  },
  {
    value: "yetkem_institute_of_catering_and_hotel_management",
    text: "Yetkem Institute of Catering and Hotel Management",
  },
  {
    value: "yewa_central_college_of_education",
    text: "Yewa Central College of Education",
  },
  {
    value: "zulikha_abiola_college_of_arabic_and_islamic_studies",
    text: "Zulikha Abiola College of Arabic And Islamic Studies",
  },
];
export const cgpas = [
  "0.1",
  "0.2",
  "0.3",
  "0.4",
  "0.5",
  "0.6",
  "0.7",
  "0.8",
  "0.9",
  "1.0",
  "1.1",
  "1.2",
  "1.3",
  "1.4",
  "1.5",
  "1.6",
  "1.7",
  "1.8",
  "1.9",
  "2.0",
  "2.1",
  "2.2",
  "2.3",
  "2.4",
  "2.5",
  "2.6",
  "2.7",
  "2.8",
  "2.9",
  "3.0",
  "3.1",
  "3.2",
  "3.3",
  "3.4",
  "3.5",
  "3.6",
  "3.7",
  "3.8",
  "3.9",
  "4.0",
  "4.1",
  "4.2",
  "4.3",
  "4.4",
  "4.5",
  "4.6",
  "4.7",
  "4.8",
  "4.9",
  "5.0",
];

export const UniversityCGPA = [
  { id: 1, value: "1st class" },
  { id: 2, value: "2nd class upper" },
];
export const PolyCGPA = [
  { id: 1, value: "Distinction" },
  { id: 2, value: "Upper credit" },
];
export const collegeCGPA = [
  { id: 1, value: "Distinction" },
  { id: 2, value: "credit" },
];
export const Award = [
  {
    id: 1,
    name: "Lagos State Bursary",
    qualify: ["Undergraduate", "Law School", "School of Maritime"],
  },
  {
    id: 2,
    name: "Lagos State Scholarship Award",
    qualify: ["Undergraduate", "Masters", "PHD"],
  },
  {
    id: 3,
    name: "Specia Scholarship for Development",
    qualify: ["Masters", "PHD"],
  },
  {
    id: 4,
    name: "Lagos State Compassionate Scholarship",
    qualify: [],
  },

  {
    id: 5,
    name: "Special Scholarship for Inclusion",
    qualify: [],
    extra: [
      "Special Scholarship for the poor and vulnerable",
      "Special Scholoarship for People Lining with Disabilities",
    ],
  },
];
